import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AttendanceReportService } from 'src/app/shared/services/attendanceservices/attendance-report.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

interface AttendanceReportRow {
  user_id: number;
  full_name: string;
  total_requests: number;
  overtime_requests: number;
  checkin_requests: number;
  checkout_requests: number;
  approved: number;
  rejected: number;
  pending: number;
}

@Component({
  selector: 'app-attendance-reports',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    LoaderComponent,
  ],
  templateUrl: './attendance-reports.component.html',
  styleUrls: ['./attendance-reports.component.scss'],
})
export class AttendanceReportsComponent implements OnInit {
  currentYear = new Date().getFullYear();
  monthOptions = this.buildCurrentYearMonths();
  selectedMonth = this.formatMonth(new Date());
  reports: AttendanceReportRow[] = [];
  isLoading = false;
  errorMessage = '';

  constructor(private attendanceReportService: AttendanceReportService) {}

  ngOnInit(): void {
    this.fetchReport();
  }

  onMonthChange(month: string): void {
    this.selectedMonth = month;
    this.fetchReport();
  }

  private fetchReport(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.attendanceReportService.getAttendanceReport(this.selectedMonth).subscribe({
      next: (response: any) => {
        const payload = response?.data ?? response;
        const rows = payload?.data ?? [];

        this.reports = Array.isArray(rows) ? rows : [];
        this.selectedMonth = payload?.month ?? this.selectedMonth;
        this.isLoading = false;
      },
      error: () => {
        this.reports = [];
        this.errorMessage = 'Unable to load attendance reports. Please try again.';
        this.isLoading = false;
      },
    });
  }

  trackByUserId(_index: number, row: AttendanceReportRow): number {
    return row.user_id;
  }

  private formatMonth(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  }

  private buildCurrentYearMonths(): { label: string; value: string }[] {
    const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return labels.map((label, index) => ({
      label: `${label} ${this.currentYear}`,
      value: `${this.currentYear}-${String(index + 1).padStart(2, '0')}`,
    }));
  }
}
